import React from 'react';
import { getNumMonthsOfLine } from '../../../utils';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme: any) => ({
  lineDuration: {
    color: theme.palette.brand.greenDark,
    fontWeight: 700,
  },
  months: {
    color: theme.palette.brand.greenDeep,
    fontWeight: 500,
  },
}));

export default function LineTotal({ line }) {
  const classes = useStyles();
  const lineDuration = getNumMonthsOfLine(line);

  return (
    <Typography variant="body2" className={classes.lineDuration}>
      {lineDuration}{' '}
      <span className={classes.months}>
        {lineDuration === 1 ? 'month' : 'months'}{' '}
      </span>
    </Typography>
  );
}
